import {z} from "zod";

export const taxAccountantConsultationSearchFormTypeSchema = z.object({
	visitedDateRangeValue: z.object({
		from: z.string().nullable().optional(),
		to: z.string().nullable().optional()
	}),
	managerIds: z.array(z.string())
});

export type TaxAccountantConsultationSearchFormType = z.infer<typeof taxAccountantConsultationSearchFormTypeSchema>;

export const taxAccountantConsultationSearchFormSchema = z.object({
	visitedAtFrom: z.string().nullable(),
	visitedAtTo: z.string().nullable(),
	managerIds: z.array(z.string())
});

export type TaxAccountantConsultationSearchType = z.infer<typeof taxAccountantConsultationSearchFormSchema>;